import {
  AppstoreOutlined,
  DesktopOutlined,
  FolderOutlined,
  LogoutOutlined,
  PieChartOutlined,
  UserOutlined
} from '@ant-design/icons'
import { Layout, Menu } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useLogoutMutation } from '../mutations'
import './styles.scss'
import { useMemo } from 'react'
const { Sider } = Layout

const SideBar = ({ ...props }) => {
  const { mutate } = useLogoutMutation()
  const location = useLocation()
  const key = location?.pathname.split('/')

  const items = useMemo(
    () => [
      {
        key: 'courses',
        label: <Link to='/admin/courses'>Events</Link>,
        icon: <PieChartOutlined />
      },
      {
        key: 'utilization-report',
        label: <Link to='/admin/utilization-report'>Utilization</Link>,
        icon: <PieChartOutlined />
      },
      {
        key: 'cases',
        label: <Link to='/admin/cases'>Cases</Link>,
        icon: <FolderOutlined />
      },
      {
        key: 'workstations',
        label: <Link to='/admin/workstations'>Workstations</Link>,
        icon: <DesktopOutlined />
      },
      {
        key: 'Softwares',
        label: <Link to='/admin/softwares'>Softwares</Link>,
        icon: <AppstoreOutlined />
      },
      {
        key: 'Licenses',
        label: <Link to='/admin/licenses'>Licenses</Link>,
        icon: <AppstoreOutlined />
      },
      {
        key: 'Upload Locations',
        label: <Link to='/admin/upload-locations'>Upload locations</Link>,
        icon: <FolderOutlined />
      },
      {
        key: 'Users',
        label: <Link to='/admin/users'>Users</Link>,
        icon: <UserOutlined />
      },
      {
        key: 'Email Templates',
        label: <Link to='/admin/email-templates'>Email templates</Link>,
        icon: <UserOutlined />
      },
      {
        key: 'Coupon Codes',
        label: <Link to='/admin/coupon-codes'>Coupon Codes</Link>,
        icon: <UserOutlined />
      },
      {
        key: 'log_out',
        label: 'Log Out',
        icon: <LogoutOutlined />,
        onClick: mutate
      }
    ],
    [mutate]
  )

  return (
    <Sider collapsible className='PageSider' {...props}>
      <div className='logo' />
      <Menu
        theme='dark'
        defaultSelectedKeys={[key[2]]}
        mode='inline'
        items={items}
      />
    </Sider>
  )
}

export default SideBar
